import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';

/**
 * Every storefront reads the country allow map. The storefront country can
 * only tighten the visitor's IP row. Keyed on `regionLocale.store`, never
 * `getBaseStore()` — the UK's base store is EU.
 *
 * ROW is a catch-all shop, not a jurisdiction, so it does not tighten.
 * EU uses Germany so a visitor from a looser country is held to the EU row.
 */
const STOREFRONT_COUNTRY: Partial<Record<ShopifyStore, string>> = {
  [ShopifyStore.US]: 'US',
  [ShopifyStore.CA]: 'CA',
  [ShopifyStore.GB]: 'GB',
  [ShopifyStore.EU]: 'DE',
  [ShopifyStore.IN]: 'IN',
  [ShopifyStore.AE]: 'AE',
  [ShopifyStore.AU]: 'AU',
  [ShopifyStore.SA]: 'SA',
  [ShopifyStore.MX]: 'MX',
  [ShopifyStore.ZA]: 'ZA',
  [ShopifyStore.JP]: 'JP',
};

export type AnalyticsStack = 'next';

export function resolveAnalyticsStack(
  _store?: ShopifyStore | string | null,
): AnalyticsStack {
  return 'next';
}

/** Country code the storefront contributes to the consent policy. */
export function storefrontCountry(
  store: ShopifyStore | string | null | undefined,
): string | null {
  if (!store) return null;
  return STOREFRONT_COUNTRY[store as ShopifyStore] ?? null;
}
